import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import useDatabase from '../../hooks/useDatabase';
import './FeaturedSandwich.css';

// Import default fallback image for sandwiches
import defaultSandwichImg from '../../assets/images/PlaceholderImage.jpg';

const FeaturedSandwich = () => {
  const { isLoading, getAllSpecialtySandwiches } = useDatabase();

  if (isLoading) return null;

  const sandwiches = getAllSpecialtySandwiches();
  const featured = sandwiches.find((s) => s.featured) || sandwiches[0];
  if (!featured) return null;

  // Dynamic slug generation based on featured sandwich name
  const slug = featured.name
    .toLowerCase()
    .replace(/^the\s+/g, '') // remove leading "the"
    .trim()
    .replace(/[^a-z0-9]+/g, '-');

  const imageUrl = `/images/sandwiches/${slug}.jpg`;

  return (
    <section className="featured-sandwich">
      <div className="container">
        <div className="featured-badge">
          <span className="star-icon">
            <FontAwesomeIcon icon={faStar} />
          </span>
          <span>Featured Special</span>
        </div>
        <div className="featured-content">
          <div className="featured-details">
            <h2 className="force-revue">{featured.name}</h2>
            <p className="featured-description">{featured.description}</p>
            <div className="featured-meta">
              <div className="featured-price">{featured.price}</div>
              <a href="tel:248-352-7377" className="btn primary">
                <FontAwesomeIcon icon={faPhoneAlt} /> Order Now
              </a>
            </div>
          </div>
          <div className="featured-image-container">
            <img 
              src={imageUrl} 
              alt={featured.name}
              className="featured-image-img"
              onError={(e) => {
                e.currentTarget.src = defaultSandwichImg;
                e.currentTarget.onerror = null; // Prevent infinite error loops
              }}
              loading="eager" // Hero/Featured image should load eagerly
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedSandwich;

